import { ValidatorFn, AbstractControl } from '@angular/forms';
import { sjisByteLength } from '../util/util';

export const validation = {
  halfBlankOnly: /[^ ]/,
  emBlankOnly: /[^　]/,
  allBlankOnly: /^(?=.*\S).+$/,
  code39: /^[ |a-zA-Z0-9|\-|.|*|$|/|+|%]+$/,
  code39Ex: /^[ |a-zA-Z0-9|\-|.|*|$|+]+$/,
  password: /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8,30}$/,

  // ユーザコード: 半角英数字
  userCdString: /^[a-z\d]{3,10}$/i,
  // ユーザ名: 半角英数字
  // userTxString: /^[a-z\d]{3,20}$/i,

  // integer: /^[+|\-|1-9][0-9]*$/,
  integerPlus: /^[+|0-9][0-9]*$/,
  exclude0: /[^0]/,

  //integer
  integer: /^[+|\-|0-9][0-9]*$/,

  //deceimal
  decimal_2: /^([+|\-]?)([0-9]*)(\.[0-9]{1,2})?$/,
  decimal_3: /^([+|\-]?)([0-9]*)(\.[0-9]{1,3})?$/,

  //alphaCapNumeric /^(|[0-9]{8})$/
  alphaCapNumeric1: /^[A-Z0-9]{1}$/,
  alphaCapNumeric2: /^[A-Z0-9]{2}$/,
  alphaCapNumeric3: /^[A-Z0-9]{3}$/,


  //mailAddress
  MailAddress: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  multiMailAddress: /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+[;,]*)*)*$/,

  //cases
  caseCd: {
    maxLength: 10,
  },
  caseTx: {
    maxLength: 20,
  },
  delisizeNr: {
    maxNr: 999,
    minNr: 0,
  },
  
  // shelves
  shelfCd: {
    maxLength: 10,
  },
  shelfTx: {
    maxLength: 20,
  },
  // shelfcases
  layerNr: {
    maxNr: 99,
    minNr: 1
  },
  orderNr: {
    maxNr: 99,
    minNr: 1
  },
  shelfcaseTx: {
    maxLength: 20,
  },

  //locas
  locaCd: {
    maxLength: 20,
  },
  locaTx: {
    maxLength: 50,
  },
  locabarcodeTx: {
    maxLength: 30,
  },
  shipnoCd: {
    maxLength: 20,
  },
  ordernoCd: {
    maxLength: 20,
  },
  srclocaCd: {
    maxLength: 20,
  },
  arrivepriorityNr: {
    maxNr: 999999,
    minNr: 0,
  },
  shippriorityNr: {
    maxNr: 999999,
    minNr: 0,
  },

  //items
  itemCd: {
    maxLength: 30,
  },
  itemTx: {
    maxLength: 40,
    maxLengthExtAas: 80,
  },
  arriveuselimitNr: {
    maxNr: 9999,
    minNr: 0,
  },
  shipuselimitNr: {
    maxNr: 9999,
    minNr: 0,
  },
  baraamountNr: {
    maxNr: 99999,
    minNr: 1,
  },
  pycaseamountNr: {
    maxNr: 99999,
    minNr: 1,
  },
  bybaracaseamountNr: {
    maxNr: 99999,
    minNr: 1,
  },
  bycaseamountNr: {
    maxNr: 99999,
    minNr: 1,
  },
  maxpbinstockNr: {
    maxNr: 999999999,
    minNr: 0,
  },
  inneramountNr: {
    maxNr: 99999,
    minNr: 1,
  },
  shipinnerNr: {
    maxNr: 99999,
    minNr: 0
  },
  innerNr: {
    maxNr: 99999,
    minNr: 0,
  },
  caseamountNr: {
    maxNr: 99999,
    minNr: 1,
  },
  casespreadNr: {
    maxNr: 999,
    minNr: 1,
  },
  casestackNr: {
    maxNr: 999,
    minNr: 1,
  },
  pcsbarcodeTx: {
    maxLength: 30,
  },
  casebarcodeTx: {
    maxLength: 30,
  },
  lengthNr: {
    maxNr: 99999,
    minNr: 0,
  },
  widthNr: {
    maxNr: 99999,
    minNr: 0,
  },
  heightNr: {
    maxNr: 99999,
    minNr: 0,
  },
  volumeNr: {
    maxNr: 99999,
    minNr: 0,
  },
  weightNr: {
    maxNr: 99999,
    minNr: 0,
  },
  innerlengthNr: {
    maxNr: 99999,
    minNr: 0,
  },
  innerwidthNr: {
    maxNr: 99999,
    minNr: 0,
  },
  innerheightNr: {
    maxNr: 99999,
    minNr: 0,
  },
  caselengthNr: {
    maxNr: 99999,
    minNr: 0,
  },
  casewidthNr: {
    maxNr: 99999,
    minNr: 0,
  },
  caseheightNr: {
    maxNr: 99999,
    minNr: 0,
  },
  casevolumeNr: {
    maxNr: 99999,
    minNr: 0,
  },
  caseweightNr: {
    maxNr: 99999,
    minNr: 0
  },
  stockunitpriceNr: {
    maxNr: 999999,
    minNr: 0,
  },
  arriveunitpriceNr: {
    maxNr: 999999,
    minNr: 0,
  },
  shipunitpriceNr: {
    maxNr: 999999,
    minNr: 0,
  },
  depositpriceNr: {
    maxNr: 9999999,
    minNr: 0,
  },
  bsupppointbaraNr: {
    maxNr: 9999999,
    minNr: 0,
  },
  bsupplimitbaraNr: {
    maxNr: 9999999,
    minNr: 0,
  },
  supppointinnercaseNr: {
    maxNr: 9999999,
    minNr: 0,
  },
  supplimitinnercaseNr: {
    maxNr: 9999999,
    minNr: 0,
  },
  supppointcaseNr: {
    maxNr: 9999999,
    minNr: 0,
  },
  supplimitcaseNr: {
    maxNr: 9999999,
    minNr: 0,
  },
  variation1Tx: {
    maxLength: 10,
  },
  variation2Tx: {
    maxLength: 10,
  },
  variation3Tx: {
    maxLength: 10,
  },
  displaypriceNr: {
    maxNr: 9999999,
    minNr: 0,
  },

  //expense
  pcsNr: {
    maxNr: 999999.999,
    minNr: -999999.999,
  },
  pricedispNr: {
    maxNr: 999999999999,
    minNr: -999999999999,
  },
  expensememoTx: {
    maxLength: 50,
  },

  //deliarea
  deliareaCd: {
    maxLength: 10,
  },
  deliareaTx: {
    maxLength: 30,
  },

  //deliroutes
  delirouteCd: {
    maxLength: 10,
  },
  delirouteTx: {
    maxLength: 30,
  },

  //ownerCarrier
  yamatocusthCd: {
    pattern: /^(|[a-zA-Z0-9!-/:-@¥[-`{-~]{12})$/,
  },
  yamatocustdCd: {
    pattern: /^(|[a-zA-Z0-9!-/:-@¥[-`{-~]{3})$/,
  },
  sagawacusthCd: {
    pattern: /^(|[0-9]{8})$/,
  },
  sagawacustdCd: {
    pattern: /^(|[0-9]{3})$/,
  },
  sagawacustcheckCd: {
    pattern: /^(|[0-9])$/,
  },
  jpcustCd: {
    pattern: /^(|[0-9]{32})$/,
  },
  seinocustCd: {
    pattern: /^(|[a-zA-Z0-9!-/:-@¥[-`{-~]{11})$/,
  },

  fukuyamacusthCd: {
    pattern: /^(|[a-zA-Z0-9!-/:-@¥[-`{-~]{10})$/,
  },
  fukuyamacustdCd: {
    pattern: /^(|[a-zA-Z0-9!-/:-@¥[-`{-~]{6})$/,
  },
  //pick
  picknoCd: {
    maxLength: 20,
  },

  //printer
  printagentTx: {
    maxLength: 50,
  },  printagentCd: {
    maxLength: 20,
  },
  printerCd: {
    maxLength: 10,
  },

  //salescategory
  salescategoryCd: {
    maxLength: 10,
  },
  salescategoryTx: {
    maxLength: 30,
  },
  creditaccCd: {
    maxLength: 10,
  },

  //salesgroup
  salesgroupCd: {
    maxLength: 10,
  },
  salesgroupTx: {
    maxLength: 30,
  },
  salesgroupunitTx: {
    maxLength: 10,
  },

  //salesgroupowner
  unitpricedispNr: {
    maxNr: 9999999,
    minNr: 0,
  },

  //stock
  lotTx: {
    maxByteLength: 20,
  },
  caseStockNr: {
    maxNr: 999999,
    minNr: 0,
  },
  baraStockNr: {
    maxNr: 999999,
    minNr: 0,
  },
  memodetTx: {
    maxLength: 21,
  },
  stockNr: {
    maxNr: 999999,
    minNr: 0,
  },
  updstockNr: {
    maxNr: 999999,
    minNr: -999999,
  },

  //stockinout
  stockinoutmemoTx: {
    maxLength: 500,
  },

  userTx: {
    minLength: 3,
    maxLength: 20,
  },

  //reqno
  reqmngCd: {
    maxLength: 20,
  },
  startreqnoNr: {
    maxNr: 99999999999,
    minNr: 0,
  },
  endreqnoNr: {
    maxNr: 99999999999,
    minNr: 0,
  },
  reqnoorderNr: {
    maxNr: 999,
    minNr: 1,
  },

  //resultmail
  mailfromTx: {
    maxLength: 100,
  },
  mailtoTx: {
    maxLength: 300,
  },
  mailccTx: {
    maxLength: 300,
  },
  mailsubjectTx: {
    maxLength: 50,
  },
  mailbodyTx: {
    maxLength: 500,
  },
  fileTx: {
    maxLength: 50,
  },

  //
  arriveplanNr: {
    maxNr: 99999,
    minNr: 0,
  },
  arrivenoCd: {
    maxLength: 20,
  },
  arriveordernoCd: {
    maxLength: 20,
  },
  arriveorderdetnoCd: {
    maxLength: 10,
  },
  memoTx: {
    maxLength: 200,
  },
  lotTx_40: {
    maxLength: 40,
  },

  // owner
  ownerCd: {
    minLength: 3,
    maxLength: 10,
  },
  ownerTx: {
    maxLength: 40,
  },
  ownerfullname1Tx: {
    maxLength: 42,
  },
  ownerfullname2Tx: {
    maxLength: 42,
  },
  extInvoicenamesuffixTx: {
    maxLength: 80,
  },
  owneraccCd: {
    maxLength: 7,
  },
  ownerpostalCd: {
    postcode: /^[0-9]{3}-[0-9]{4}$/,
    maxLength: 9,
  },
  owneraddress1Tx: {
    maxLength: 40,
    postcode: /^[0-9]{3}-[0-9]{4}$/,
  },
  owneraddress2Tx: {
    maxLength: 40,
  },
  owneraddress3Tx: {
    maxLength: 40,
  },
  ownertelTx: {
    tel: /^[0-9]{9,13}$/,
    maxLength: 20,
  },
  yamatobasenoCd: {
    maxLength: 3,
  },
  //dtAdress
  dtaddressCd: {
    maxLength: 30,
  },
  dtnameTx: {
    maxLength: 50,
  },
  dtpostalCd: {
    postcode: /^[0-9]{3}-[0-9]{4}$/,
    maxLength: 10,
  },
  dtaddress1Tx: {
    maxLength: 40,
  },
  dtaddress2Tx: {
    maxLength: 40,
  },
  dtaddress3Tx: {
    maxLength: 40,
  },
  dtaddress4Tx: {
    maxLength: 40,
  },
  dtdepartmentTx: {
    maxLength: 90,
  },
  dttelTx: {
    tel: /^[0-9-]{9,13}$/,
    maxLength: 20,
  },
  delimemodet1Tx: {
    maxLength: 32,
  },
  delimemodet2Tx: {
    maxLength: 32,
  },
  delimemodet3Tx: {
    maxLength: 32,
  },
  delimemodet4Tx: {
    maxLength: 32,
  },
  delimemodet5Tx: {
    maxLength: 32,
  },
  delimemodet6Tx: {
    maxLength: 32,
  },
  freeItem1Tx: {
    maxLength: 50,
  },
  freeItem2Tx: {
    maxLength: 50,
  },

  // maShipcase 出荷ケースマスタ
  shipcaseCd: {
    maxLength: 10,
  },
  shipcaseTx: {
    maxLength: 20,
  },
  shipcaseLengthNr: {
    maxNr: 99999.999,
    minNr: 0.000,
  },
  shipcaseWidthNr: {
    maxNr: 99999.999,
    minNr: 0.000,
  },
  shipcaseHeightNr: {
    maxNr: 99999.999,
    minNr: 0.000,
  },
  shipcaseCapacityRateNr: {
    maxNr: 100,
    minNr: 1,
  },

  // pickcase ピック箱マスタ
  pickcaseCd: {
    maxLength: 10,
  },
  pickcaseTx: {
    maxLength: 20,
  },
  pickcaseVolumeNr: {
    maxNr: 99999.999,
    minNr: 0.000,
  },
  pickcaseCapacityRateNr: {
    maxNr: 100,
    minNr: 1,
  },

  // 搬送什器マスタ
  carrierdeviceTx: {
    maxLength: 20,
  },
  carrierdeviceWidthNr: {
    maxNr: 99999.99,
    minNr: 0.00,
  },
  carrierdeviceDepthNr: {
    maxNr: 99999.99,
    minNr: 0.00,
  },
  carrierdeviceHeightNr: {
    maxNr: 99999.99,
    minNr: 0.00,
  },
  fillinglimitNr: {
    maxNr: 100,
    minNr: 1,
  },

  message: {
    //input rules
    required: '必須です。',
    notOnlyBlank: '空白だけの登録は出来ません。',
    notPostcode: '[123-4567]形式で入力してください。',
    notTelnumber: 'ハイフンなしで正しく入力してください。',
    notTelnumber2: '電話番号を正しく入力してください。',//ハイフン許可
    password: '英数含む8文字以上30文字以内で入力してください。',
    mailAddress: 'メールアドレスの入力が不正です。',
    alphaCapNumeric1: '半角英数大文字１桁で入力してください。',
    alphaCapNumeric2: '半角英数大文字２桁で入力してください。',
    alphaCapNumeric3: '半角英数大文字３桁で入力してください。',
    multiMailAddress: '複数アドレスは ; または , で区切ってください。',
    maxLength: '文字数の上限を超えています。最大文字数：',
    minLength: '文字数の下限を下回っています。最小文字数：',
    maxByteLength: '全角10文字以下、半角20文字以下で指定して下さい。',
    maxNr: '数量の上限を超えています。最大入力数：',
    minNr: '以上の数を入力してください。',
    code39: '半角の英数字,スペースもしくは指定記号(-,.,*,$,/,+,%)で入力してください。',
    code39Ex: '半角の英数字,スペースもしくは指定記号(-,.,*,$,+)で入力してください。',
    exclude0: '0での登録は出来ません。',
    integer: '整数(0~9)で入力してください。',
    integerPlus: '正の整数で入力してください。',
    integerExclude0: '0以外の整数で入力してください。',
    decimal_2: '数値で入力してください(小数は2桁以内)。',
    decimal_3: '数値で入力してください(小数は3桁以内)。',
    priceOver: '金額が上限を超えています。上限額：',
    //no masterdata
    onwer: '該当する荷主はマスタに登録されていません',
    salesgroups: '該当する項目はマスタに登録されていません',
    //delete
    delete: {
      detail: '明細数をゼロにすることはできません。'
    },
    userCdString: '半角英数3文字以上10文字以内で入力してください。',
    //固定文字数
    numberFix8: '半角数字8桁で入力してください。',
    numberFix3: '半角数字3桁で入力してください。',
    numberFix1: '半角数字1桁で入力してください。',
    numberFix32: '半角数字32桁で入力してください。',
    numberFix12: '半角数字12桁で入力してください。',
    asciiFix3: '半角英数字記号3桁で入力してください。',
    asciiFix6: '半角英数字記号6桁で入力してください。',
    asciiFix10: '半角英数字記号10桁で入力してください。',
    asciiFix11: '半角英数字記号11桁で入力してください。',
    asciiFix12: '半角英数字記号12桁で入力してください。',
    dtaddressCd: '半角の英数字,もしくは指定記号(-,.,*,$,/,+,%)で入力してください。',
    caseLocaMixitemFl: '標準ケース使用ロケのため、商品混載可にできません。',
    caseLocaMixlotFl: '標準ケース使用ロケのため、ロット混載不可にできません。'
  },

};

export function validateMaxByteLength(maxByteLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return sjisByteLength(control.value) > maxByteLength ? { 'maxByteLength': { valid: false } } : null;
  };
};


// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/util/validation.ts